import React, { useEffect, useState, useMemo } from "react";
import Grid from "@mui/material/Grid";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import ReportsBarChart from "examples/Charts/BarCharts/ReportsBarChart";
import ReportsLineChart from "examples/Charts/LineCharts/ReportsLineChart";
import ComplexStatisticsCard from "examples/Cards/StatisticsCards/ComplexStatisticsCard";
import reportsBarChartData from "layouts/dashboard/data/reportsBarChartData";
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";
import useAuthStore from "store/authStore";
import axios from "axios";
import { IoCopyOutline } from "react-icons/io5";
import { CircularProgress } from "@mui/material";
import { BASE_URL } from "service";

function Dashboard() {
  const { sales, tasks } = reportsLineChartData;
  const [seen, setSeen] = useState(0);
  const [promotionCode, setPromotionCode] = useState("");
  const [loading, setLoading] = useState(true);
  const [isLoadingTasks, setIsLoadingTasks] = useState(true);
  const [selfEarning, setSelfEarning] = useState("0");
  const [dailyDirectEarning, setDailyDirectEarning] = useState("0");
  const [dailyTotalEarning, setDailyTotalEarning] = useState("0");
  const [earnings, setEarnings] = useState(null);

  const { email } = useAuthStore();

  const [visitedLinks, setVisitedLinks] = useState(
    useMemo(() => {
      const stored = localStorage.getItem("visitedLinks");
      if (stored) {
        const { date, links, tasksSubmitted, email: storedEmail } = JSON.parse(stored);
        const today = new Date().toDateString();
        if (date === today && storedEmail === email) {
          return { links, tasksSubmitted };
        }
      }
      return { links: {}, tasksSubmitted: false };
    }, [email])
  );

  const safeSubtract = (a, b) => ((Number(a) || 0) - (Number(b) || 0)).toFixed(2);
  const tasksCount = useMemo(() => Object.keys(visitedLinks.links).length, [visitedLinks.links]);
  const isSubmitted = useMemo(() => visitedLinks.tasksSubmitted, [visitedLinks]);

  // Compute formattedDate at component level
  const formattedDate = useMemo(() => {
    const today = new Date();
    const day = String(today.getDate()).padStart(2, "0");
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const year = today.getFullYear();
    return `${day}${month}${year}`; // e.g. "08062025"
  }, []);

  // Fetch visited links and task data
  const fetchCardsAndTasks = async () => {
    try {
      setIsLoadingTasks(true);

      // Fetch user's task data
      const tasksResponse = await axios.get(`${BASE_URL}/api/dailyTasks/tasksByUser/${email}`, {
        headers: { "Content-Type": "application/json" },
      });

      const tasksData = tasksResponse.data.data;
      // console.log("tasksData    ", tasksData);

      // console.log(
      //   ` todayTask[${formattedDate}]   - `,
      //   tasksData.tasks.hasOwnProperty(formattedDate)
      // );
      console.log("tasksData.email----", tasksData.email, " - ", email);
      if (tasksData && tasksData.email === email) {
        // 🔹 FIX: Check if tasks is already an object or needs parsing
        const tasks =
          typeof tasksData.tasks === "string" ? JSON.parse(tasksData.tasks) : tasksData.tasks;
        const todayTask = tasks.find((task) => task.hasOwnProperty(formattedDate));
        console.log("+ todayTask[formattedDate]   ++ ", todayTask[formattedDate]);
        console.log("tasks---", todayTask);

        if (todayTask && todayTask[formattedDate] && !visitedLinks.tasksSubmitted) {
          // Create full links object: { "1": true, ..., "20": true }
          const allLinks = {};
          for (let i = 1; i <= 20; i++) {
            allLinks[i] = true;
          }

          // Update React state
          setVisitedLinks({
            links: allLinks,
            tasksSubmitted: true,
          });

          // Save to localStorage
          localStorage.setItem(
            "visitedLinks",
            JSON.stringify({
              date: new Date().toDateString(),
              email,
              links: allLinks,
              tasksSubmitted: true,
            })
          );
          // Update seen count
          setSeen(20);
        } else {
          // Update seen count from localStorage
          const stored = localStorage.getItem("visitedLinks");
          if (stored) {
            const parsedLinks = JSON.parse(stored);
            const visitedCount = Object.keys(parsedLinks.links || {}).length;
            setSeen(visitedCount);
          }
        }
      }
    } catch (error) {
      console.error("Error fetching task data:", error);
      // Fallback to localStorage if API fails
      const stored = localStorage.getItem("visitedLinks");
      if (stored) {
        const parsedLinks = JSON.parse(stored);
        const visitedCount = Object.keys(parsedLinks.links || {}).length;
        setSeen(visitedCount);
      }
    } finally {
      setIsLoadingTasks(false);
    }
  };

  useEffect(() => {
    fetchCardsAndTasks();
  }, []);

  // useEffect(() => {
  //   fetchCardsAndTasks();
  // }, [email]);

  // Reset visitedLinks and submission status daily at 11:59 PM
  useEffect(() => {
    const checkDateAndTime = () => {
      const now = new Date();
      const today = now.toDateString();
      const hours = now.getHours();
      const minutes = now.getMinutes();
      const seconds = now.getSeconds();

      // Check if it's 11:59 PM
      if (hours === 23 && minutes === 59 && seconds >= 0 && tasksCount === 20 && isSubmitted) {
        setVisitedLinks({ links: {}, tasksSubmitted: false });
        setSeen(0);
        localStorage.setItem(
          "visitedLinks",
          JSON.stringify({
            date: today,
            email,
            links: {},
            tasksSubmitted: false,
          })
        );
      }

      // Check if date has changed or email doesn't match
      const storedLinks = localStorage.getItem("visitedLinks");
      if (storedLinks) {
        const { date, email: storedEmail } = JSON.parse(storedLinks);
        if (date !== today || storedEmail !== email) {
          setVisitedLinks({ links: {}, tasksSubmitted: false });
          setSeen(0);
          localStorage.setItem(
            "visitedLinks",
            JSON.stringify({
              date: today,
              email,
              links: {},
              tasksSubmitted: false,
            })
          );
        }
      } else {
        localStorage.setItem(
          "visitedLinks",
          JSON.stringify({
            date: today,
            email,
            links: {},
            tasksSubmitted: false,
          })
        );
      }
    };

    checkDateAndTime();
    const interval = setInterval(checkDateAndTime, 1000); // Check every second
    return () => clearInterval(interval);
  }, [email, tasksCount, isSubmitted]);

  // Fetch promotion code
  useEffect(() => {
    setTimeout(() => {
      const code = localStorage.getItem("referral_code");
      setPromotionCode(code || "No Code Found");
      setLoading(false);
    }, 500);
  }, []);

  // Fetch earning details from API
  useEffect(() => {
    const fetchEarnings = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/api/earning/dailyselfearning/?email=${encodeURIComponent(email)}`
        );
        // console.log("+- ", response);
        // const earnings = response.data.earnings;
        setEarnings(response.data.earnings);

        setSelfEarning(earnings.daily_self_earning);
        setDailyDirectEarning(earnings.daily_direct_earning || "0");
        setDailyTotalEarning(earnings.total_team_earning || "0");
      } catch (error) {
        // console.error("Error fetching earnings:", error);
      }
    };

    if (email) {
      fetchEarnings();
    }
  }, [email]);

  const totalLinks = 20;

  // Update self earning when all tasks are completed
  // useEffect(() => {
  //   if (seen === totalLinks && selfEarning === "0") {
  //     setSelfEarning("9");
  //     axios
  //       .post(`${BASE_URL}/api/earning/dailyselfearning/?email=${email}`, {
  //         dailySelfEarning: "9",
  //       })
  //       .then((response) => {
  //         console.log("Earning API response:", response.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error posting self earning:", error);
  //       });
  //   }
  // }, [seen, email, selfEarning]);

  // useEffect(() => {
  //   if (seen === totalLinks && selfEarning === "0") {
  //     // Fetch daily_earning_amount dynamically
  //     axios
  //       .get(`${BASE_URL}/api/levelamount/get`)
  //       .then((res) => {
  //         const dailyEarning = res.data?.data?.[0]?.daily_earning_amount || "0"; // Default to "0" if not found
  //         setSelfEarning(dailyEarning);

  //         // Now post this daily earning
  //         return axios.post(`${BASE_URL}/api/earning/dailyselfearning/?email=${email}`, {
  //           // dailySelfEarning: 1000, // TODO
  //         });
  //       })
  //       .then((response) => {
  //         console.log("Earning API response:", response.data);
  //       })
  //       .catch((error) => {
  //         console.error("Error handling self earning:", error);
  //       });
  //   }
  // }, [seen, email, selfEarning]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={3}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              {loading ? (
                <CircularProgress size={24} color="primary" />
              ) : (
                <ComplexStatisticsCard
                  color="error"
                  icon="weekend"
                  iconType="IoShareSocial"
                  title="Promotion Code"
                  count={promotionCode}
                  percentage={{
                    color: "success",
                    amount: (
                      <div
                        onClick={() => {
                          navigator.clipboard.writeText(
                            `kamaiclub.com/register?r_code=${promotionCode}`
                          );
                          alert("Copied to clipboard!");
                        }}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                          marginRight: 10,
                        }}
                      >
                        <IoCopyOutline size={22} />
                      </div>
                    ),
                    label: `kamaiclub.com/register?r_code=${promotionCode}`,
                  }}
                />
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              {isLoadingTasks ? (
                <CircularProgress size={24} color="primary" />
              ) : (
                <ComplexStatisticsCard
                  color="dark"
                  icon="weekend"
                  iconType="FaTasks"
                  title="Today's Tasks"
                  count={seen === totalLinks ? "20" : `${seen}/${totalLinks}`}
                  percentage={{
                    color: "success",
                    amount: `${totalLinks}`,
                    label: seen === totalLinks ? "Seen All Tasks" : "Tasks Unseen for Today",
                  }}
                />
              )}
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                icon="leaderboard"
                iconType="GiReceiveMoney"
                title="Self Earning"
                // count={`Rs ${earnings.daily_self_earning}`}
                count={(Number(earnings?.daily_self_earning) || 0).toFixed(2)}
                percentage={{
                  color: "success",
                  amount: "Rs 9.00",
                  label: "For completed all tasks",
                }}
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={3}>
            <MDBox mb={1.5}>
              <ComplexStatisticsCard
                color="primary"
                iconType="CiBank"
                icon="person_add"
                title="Team Earning"
                // count={(
                //   Number(earnings?.life_time_earning) - Number(earnings?.total_self_earning)
                // ).toFixed(2)}
                // count={safeSubtract(earnings?.life_time_earning, earnings?.total_self_earning)}
                count={(
                  Math.round(
                    (Number(earnings?.total_direct_earning || 0) +
                      Number(earnings?.total_team_earning || 0)) *
                      100
                  ) / 100
                ).toFixed(2)}
                // count={`Rs ${dailyTotalEarning}`}
                percentage={{
                  color: "success",
                  // amount: `Rs ${earnings.daily_team_earning}`,
                  label: "Today's Team Earning",
                }}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox mt={4.5}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsBarChart
                  color="info"
                  title="website views"
                  description="Last Campaign Performance"
                  date="campaign sent 2 days ago"
                  chart={reportsBarChartData}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="success"
                  title="daily sales"
                  description={
                    <>
                      (<strong>+15%</strong>) increase in today sales.
                    </>
                  }
                  date="updated 4 min ago"
                  chart={sales}
                />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={4}>
              <MDBox mb={3}>
                <ReportsLineChart
                  color="dark"
                  title="completed tasks"
                  description="Last Campaign Performance"
                  date="just updated"
                  chart={tasks}
                />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Dashboard;
